module.exports = __webpack_public_path__ + "img/uk_success_3.94973371.png";